import { getTimMsg } from 'src/local-logic/tip-match/tim/get-msg';
import { getTimUnReadCount } from 'src/local-logic/tip-match/tim/get-unread-count';

const NEW_MESSAGE_MAX_GAP = 12;

export function storeGetTimMsg(context /* uid*/) {
  getTimMsg({
    operator_account: 'esportRobot',
    // peer_acount: uid, // 后台自己取
    max_cnt: 100,
    min_time: Math.floor(Date.now() / 1000 - 7 * 24 * 60 * 60),
    max_time: Math.floor(Date.now() / 1000),
  }).then((res: any) => {
    const newMsg = parseRobotMsgList(res);
    context.commit('setESportRobotNewMsg', newMsg);
  })
    .catch((err) => {
      console.warn('vuex.getTimMsg.err', err);
    });
}

export function storeGetUnreadCount(context, uid, acount?: Array<string>) {
  getTimUnReadCount({
    // To_Account: uid,
    acount,
  }).then((res) => {
    if (acount) {
      context.commit('setMsgCountpolling', res);
      return;
    }
    context.commit('setUnreadMsgCount', {
      count: res,
      from: 'open-api',
    });
  })
    .catch((err) => {
      console.log('vuex.getTimUnReadCount.err', err);
    });
}


// 设置战队新消息
export function storeGetTeamUnreadCount(context, uid, acount?: Array<string>) {
  getTimUnReadCount({
    // To_Account: uid,
    acount,
  }).then((res) => {
    context.commit('setTeamUnreadMsgCount', res);
  })
    .catch((err) => {
      console.log('vuex.getTimUnReadCount.err', err);
    });
}


// 设置战队新消息
export function storeGetRobotsUnreadCount(context) {
  getTimUnReadCount({
    // To_Account: uid,
    acount: ['teamRobot', 'esportRobot'],
    needObjResp: true,
  }).then((res) => {
    const innerRes = res as {
      all: number;
      [key: string]: number;
    };
    context.commit('setTeamUnreadMsgCount', innerRes.teamRobot || 0);
    context.commit('setMsgCountpolling', (innerRes.teamRobot || 0) + (innerRes.esportRobot || 0));
  })
    .catch((err) => {
      console.log('vuex.getTimUnReadCount.err', err);
    });
}


function isLatestMsg(msg) {
  if (!msg.MsgTimeStamp) return false;
  const gap = Math.ceil(Date.now() / 1000) - msg.MsgTimeStamp;
  if (gap < NEW_MESSAGE_MAX_GAP) {
    return true;
  }
  return false;
}

function parseRobotMsgList(obj: Record<string, any> = {}) {
  const list = obj.MsgList || [];
  list.sort((a, b) => b.MsgTimeStamp - a.MsgTimeStamp);
  const unreadList = list.filter(item => !item.IsPeerRead);
  if (!unreadList.length) return null;
  if (!isLatestMsg(unreadList[0])) {
    return null;
  }
  const res: Record<string, any> = parseMsg(unreadList[0]?.MsgBody?.[0]?.MsgContent?.Text || '');
  if (res && typeof res.content === 'string') {
    res.content = res.content.replace('\\n', '').replace('\n', '');
  }

  return res;
}

function parseMsg(msg = '') {
  let res = {};
  try {
    res = JSON.parse(msg);
  } catch (err) {
  }
  return res;
}

